import { useNavigate } from '@tanstack/react-router';
import { useAuth } from '../../contexts/AuthContext';
import { LogOut } from 'iconoir-react';

export const SignOutButton: React.FC = () => {
  const { firebaseSignOut } = useAuth();
  const navigate = useNavigate();
  const handleSignOut = async () => {
    // Flag prevents login.tsx nav effect from acting on stale currentUser
    // before onAuthStateChanged propagates null to React state.
    sessionStorage.setItem('pendingSignOut', 'true');
    await firebaseSignOut();
    window.localStorage.removeItem('emailForSignIn');
    navigate({ to: '/login' });
  };
  return (
    <button id="signOut-button" type="button" onClick={() => handleSignOut()} style={{ cursor: 'pointer' }}>
      <LogOut height={'2em'} width={'2em'} color="#fff" />
    </button>
  );
};
